module.exports = __webpack_public_path__ + "img/chat-wedget-white.924b9c1f.png";